const Quiz = () => {
  return (
    <div className="flex justify-center items-center min-h-screen mt-9">
      <iframe src="https://chat.gigabytemultimidia.com.br/quiz-seguran-a-da-informa-o-7pjldy5"
        className="border-0 w-full h-screen"
        name="myiFrame"
        scrolling="no"
        frameBorder="1"
        marginHeight="0"
        marginWidth="0"
        allowFullScreen></iframe>
    </div>

  )
}
export default Quiz;